<template>
    <div class="sap-select">
        <v-radio-group
            column
            @change="setSap"
            :label="label"
            :rules="sapRules"
            :value="sap"
            :loading="loading"
            :disabled="loading"
        >
            <v-radio
                v-for="s in saps"
                :key="s.value"
                :color="s.color"
                :value="s.value"
                :label="s.label">
            </v-radio>
        </v-radio-group>
    </div>
</template>
<script>

export default {
    name: 'SapSelect',
    props: ['sap', 'loading', 'label'],
    data() {
        return {
            saps: [{
                color: 'success',
                label: 'MHN',
                value: 'MHN',
            }, {
                color: 'success',
                label: 'NOZ',
                value: 'NOZ',
            }],
            sapRules: [
                v => (!!v) || 'Es muss ein SAP ausgewählt werden',
            ],
        };
    },
    methods: {
        setSap(payload) {
            this.$emit('change', payload);
        },
    },
};

</script>
<style lang="scss" scoped>
    .v-input--radio-group__input > label.v-label {
        font-weight: bold;
    }
</style>
